module.exports = __webpack_public_path__ + "static/media/menuBill.bbc3719d.svg";